export const KnownMappingNodeKeys = {
  Variation: "variation",
  Subject: "Matière",
  Source: "Source",
  Point: "Point",
  Notion: "Notion clé",
  Blocage: "Blocage",
} as const;
export type KnownMappingNodeKeys =
  (typeof KnownMappingNodeKeys)[keyof typeof KnownMappingNodeKeys];

export const displayableKeys: string[] = [
  KnownMappingNodeKeys.Point,
  KnownMappingNodeKeys.Notion,
];

export interface MappingNode {
  depth: number;
  id: string;
  key: string;
  value: string;
  children: MappingNode[];
  mapping_metadata: MappingMetadata | null;
}

export interface MappingMetadata {
  levels?: string[];
}

export const adaptiveTestResultNode = (
  moduleCode: string,
  testStatus: string,
) => `${moduleCode}-TAI${testStatus}`;

export const objectiveBlockedResultNode = (objectiveCode: string) =>
  `${objectiveCode}-blocked`;
